import React from "react";
import { ThemeProvider } from "./ThemeProvider";
import { I18nProvider } from "./I18nProvider";
import { ConfirmProvider } from "./ConfirmProvider";
import { AuthProvider } from "../contexts/AuthContext";

const AppProviders = ({ children }) => {
  return (
    <ThemeProvider>
      <I18nProvider>
        <ConfirmProvider>
          <AuthProvider>{children}</AuthProvider>
        </ConfirmProvider>
      </I18nProvider>
    </ThemeProvider>
  );
};

export default AppProviders;
